import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Ok",
  "use": "Ok-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"Ok\"><path fill-rule=\"evenodd\" d=\"M16 21.926l8.308-11.866 2.857 2-10.314 14.731-2.857-2 .006-.008-5.343-3.741 2-2.857L16 21.926zm2 13.512C8.37 35.438.562 27.63.562 18 .563 8.37 8.37.562 18 .562 27.63.563 35.438 8.37 35.438 18c0 9.63-7.808 17.438-17.438 17.438zm0-4.5c7.145 0 12.938-5.793 12.938-12.938 0-7.145-5.793-12.938-12.938-12.938-7.145 0-12.938 5.793-12.938 12.938 0 7.145 5.793 12.938 12.938 12.938z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol